// Hosted DEV environment — used by `npm run build:dev` (Azure Static Web App: web-dev.orderyaa.com).
// Static deploy (no SSR proxy), so API calls need an absolute, internet-reachable URL — NOT localhost.
// (Local `ng serve` keeps localhost via environment.development.ts.)
export const environment = {
  production: false,
  apiBaseUrl: 'https://app-tc-mobilizer-api-dev-c8g0emgzgwame8dy.southindia-01.azurewebsites.net',
  erpBaseUrl: 'https://dev.orderyaa.com/',
  erpDomain: 'orderyaa.com',
  // Must match the API's Authentication:Google config; the web-dev.orderyaa.com origin must be in
  // the OAuth client's Authorized JavaScript origins.
  googleClientId: '391317514379-i03p4086pvq91sdctrnil77dps12dhqr.apps.googleusercontent.com',
  facebookAppId: '',
  searchInStoresTenantId: '',
  platformCompanyId: '67bce460-85e1-42e2-a01a-03081faa41f0',
  platformBranchId: '064f70ec-dd2f-4c9a-b966-c4ac026b95ae',
  platformBusinessUnitId: '52ead974-3e90-4da9-9679-ee38e6da32e8',
  // Firebase Web push (FCM). Fill from Firebase Console → Project settings:
  //  • General → "Your apps" (Web app) config: apiKey, messagingSenderId, appId.
  //  • Cloud Messaging → "Web Push certificates" → firebaseVapidKey (public key).
  // projectId is fixed; empty apiKey/appId/vapidKey simply disables push (no error thrown).
  firebase: {
    apiKey: 'AIzaSyBhajd07PIVU_0z6KAnAyTEC7mlbqBYsHE',
    authDomain: 'orderyaa-b996c.firebaseapp.com',
    projectId: 'orderyaa-b996c',
    storageBucket: 'orderyaa-b996c.firebasestorage.app',
    messagingSenderId: '786741790179',
    appId: '1:786741790179:web:5490b9b92595d3d59c0cd6',
  },
  firebaseVapidKey: 'BHMJJqk6QKJR8KBKkl9TRu2zroAbckUMA7I8Kdw17IgGW8p1ynfa2Es9IzX2t6htTa05I7vrlDItWPvYCHYJppk',
};
